import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Live_ais_data from "./Live_ais_data";
import AIS_past_data from "./AIS_past_data";
import Sel_AIS_all_data from "./Sel_AIS_all_data";
import usePageTracking from "./usePageTracking";

export default function AppRoutes() {
    usePageTracking(); 

    return (
        <Routes>
            <Route path="/" element={<Live_ais_data />} />
            <Route path="/live_ais_data" element={<Live_ais_data />} />
            <Route path="/ais_past_data" element={<AIS_past_data />} />
            <Route path="/sel_ais_data_all" element={<Sel_AIS_all_data />} />
        </Routes>
    );
}
